import axios from 'axios';

/**
 * Default axios client from `@nova/network`’s `axios` dependency. Use this (and `AxiosInstance` from this package)
 * when passing HTTP into `@nova/age` `Match` REST helpers so TypeScript does not mix duplicate `axios` declaration paths.
 */
export const axiosHttp = axios;

export const getAxiosErrorCode = (reason: unknown): string | undefined =>
  axios.isAxiosError(reason) ? reason.code : undefined;

export const getAxiosErrorStatus = (reason: unknown): number | undefined =>
  axios.isAxiosError(reason) ? reason.response?.status : undefined;
